// Module
var code = `<div id="error-{{::VM.errorId}}" ng-hide="VM.loading" class="public-content layout-column flex-center fullHeightPage"> <rb-error error="VM.message" class="layout-column"></rb-error> </div> `;
// Exports
export default code;